import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { PiecesService } from 'app/services/pieces/pieces.service';
import { ProjetsService } from 'app/services/projets/projets.service';
import { SousBienService } from 'app/services/sousBiens/sous-bien.service';
import { AwscontrolService } from 'app/services/aws/awscontrol.service';
import Swal from 'sweetalert2';
import { Location } from '@angular/common';
import { BiensImmobsBiensImmobs } from 'app/services/biens-immobs/biens-immobs.service';

@Component({
  selector: 'app-list-sous-bien',
  templateUrl: './list-sous-bien.component.html',
  styleUrls: ['./list-sous-bien.component.scss']
})
export class ListSousBienComponent implements OnInit {
  idAgency: any;           // Bien ID from route
  Agency: any;             // Parent bien data
  agencyIdForNav: string | null = null; // Agency ID extracted from parent bien
  projects: any[];
  list: any;
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = ['id', 'image', 'projet', 'agence', 'role', 'action'];

  constructor(
    private SousBienService: SousBienService,
    private piecesService: PiecesService,
    private agencieService: AgenciesService,
    private activatedRoute: ActivatedRoute,
    private projetService: ProjetsService,
    private location: Location,
    private router: Router,
    private sous: BiensImmobsBiensImmobs,
    private awsService: AwscontrolService
  ) { }

  ngOnInit(): void {
    this.idAgency = this.activatedRoute.snapshot.paramMap.get('id');
    this.agencieService.setIdAgency(this.idAgency);

    // Use 'any' to avoid TypeScript errors with dynamic properties
    this.sous.getBiensImmobs(this.idAgency).subscribe((data: any) => {
      this.Agency = data;
      // Extract agency ID from the parent bien
      if (data.userId) {
        this.agencyIdForNav = data.userId.toString();
      } else if (data.user?.id) {
        this.agencyIdForNav = data.user.id.toString();
      }

      this.list = this.Agency.sous_biens;
      console.log('Sous-biens:', this.Agency.sous_biens);

      if (this.list) {
        this.list.sort((a, b) => {
          const createdAtA = this.parseDate(a.createdAt);
          const createdAtB = this.parseDate(b.createdAt);
          return createdAtA.getTime() - createdAtB.getTime();
        });
      }
    });
  }

  // Helper function to parse date string into Date object
  private parseDate(dateString: string): Date {
    if (!dateString) return new Date(0);
    const parts = dateString.split(/[\s/:]+/);
    if (parts.length >= 6) {
      const [day, month, year, hour, minute, second] = parts.map(Number);
      return new Date(year, month - 1, day, hour, minute, second);
    }
    return new Date(dateString);
  }

  getData(): void {
    this.agencieService.getAgencieById(this.idAgency).subscribe((data: any) => {
      this.Agency = data;
      this.list = this.Agency.biens?.sous_biens;
      console.log(this.Agency, this.list);
    });
  }

  // ============================================================
  // DELETE with AWS image removal
  // ============================================================

  deleteSousBien(sousBien: any): void {
    Swal.fire({
      title: "Êtes-vous sûr(e) ?",
      text: "Vous ne pourrez pas revenir en arrière !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, supprimez-le."
    }).then((result) => {
      if (result.isConfirmed) {
        // Show loading
        Swal.fire({
          title: 'Suppression en cours...',
          text: 'Veuillez patienter',
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: () => Swal.showLoading()
        });

        // 1. Delete images from AWS
        this.deleteImagesFromS3(sousBien)
          .then(() => {
            // 2. Delete sous-bien from backend
            return this.SousBienService.deleteSousBien(sousBien.id).toPromise();
          })
          .then(() => {
            Swal.close();
            Swal.fire('Supprimé !', 'Le sous-bien et ses images ont été supprimés.', 'success');
            // Refresh the list
            this.getData();
          })
          .catch((err) => {
            Swal.close();
            console.error('Erreur lors de la suppression:', err);
            // If image deletion fails, we still try to delete the sous-bien
            this.SousBienService.deleteSousBien(sousBien.id).subscribe({
              next: () => {
                Swal.fire('Supprimé !', 'Le sous-bien a été supprimé (images non supprimées).', 'success');
                this.getData();
              },
              error: (err2) => {
                Swal.fire('Erreur', 'La suppression a échoué.', 'error');
                console.error(err2);
              }
            });
          });
      }
    });
  }

  private async deleteImagesFromS3(sousBien: any): Promise<void> {
    const imageUrls: string[] = [];

    // Main image
    if (sousBien.image_url && sousBien.image_url.trim() !== '') {
      imageUrls.push(sousBien.image_url);
    }

    // Gallery images (imagesList)
    if (sousBien.imagesList && Array.isArray(sousBien.imagesList)) {
      sousBien.imagesList.forEach((url: string) => {
        if (url && url.trim() !== '') {
          imageUrls.push(url);
        }
      });
    }

    if (imageUrls.length === 0) {
      return;
    }

    const deletePromises = imageUrls.map(url =>
      this.awsService.deleteFile(url).toPromise().catch(err => {
        console.warn(`Failed to delete image ${url}:`, err);
        return Promise.resolve();
      })
    );

    await Promise.all(deletePromises);
  }

  // ============================================================
  // NAVIGATION
  // ============================================================

  navigateBack(): void {
    if (this.agencyIdForNav) {
      this.router.navigate(['/list-biens', this.agencyIdForNav]);
    } else {
      // Fallback: go to previous page or to the list of biens for the current id
      this.location.back();
    }
  }
}